import { getInitials } from "@reactive-resume/utils";

import { useAuthStore } from "../stores/auth";

type Props = {
  size?: number;
  className?: string;
};

export const UserAvatar = ({ size = 36, className }: Props) => {
  const { user } = useAuthStore();

  if (!user) return null;

  let picture: React.ReactNode;

  // Handle both old and new user structure
  const userMetadata = user.user_metadata ?? {};
  // eslint-disable-next-line lingui/no-unlocalized-strings
  const userName = userMetadata.name ?? userMetadata.full_name ?? user.email ?? "User";
  const userPicture = userMetadata.picture ?? userMetadata.avatar_url;

  if (userPicture) {
    picture = (
      <img
        alt={userName}
        src={userPicture}
        className="rounded-full"
        style={{ width: size, height: size }}
      />
    );
  } else {
    const initials = getInitials(userName);

    picture = (
      <div
        style={{ width: size, height: size }}
        className="flex items-center justify-center rounded-full bg-secondary text-center text-[10px] font-semibold text-secondary-foreground"
      >
        {initials}
      </div>
    );
  }

  return <div className={className}>{picture}</div>;
};
